import * as React from 'react';

import { Box } from '@mui/material';
import TabsContentData, { TabsContentDataBaseProps } from './TabsContentData';
import TabsContentModels, { TabsContentModelsBaseProps } from './TabsContentModels';
import TabsContentMonitoring from './TabsContentMonitoring';
import TabsContentSchema, { TabsContentSchemaBaseProps } from './TabsContentSchema';
import TabsContentReadme, { TabsContentReadmeBaseProps } from './TabsContentReadme';


type TabsContentProps = TabsContentDataBaseProps & TabsContentSchemaBaseProps & TabsContentModelsBaseProps & TabsContentReadmeBaseProps & {
  tabId: number
}

const TabsContent = (props: TabsContentProps) => {

  const getIsVisible = React.useCallback((i: number) => {
    return i === props.tabId
  }, [props.tabId]);

  return <Box>
    <TabsContentReadme {...props} isVisible={getIsVisible(0)} />
    <TabsContentData {...props} isVisible={getIsVisible(1)} />
    <TabsContentModels {...props} isVisible={getIsVisible(2)} />
    <TabsContentSchema {...props} isVisible={getIsVisible(3)} />
    <TabsContentMonitoring {...props} isVisible={getIsVisible(4)} />
  </Box>
}

export default TabsContent;
